module.exports = __webpack_public_path__ + "static/story_photo_01-748521d8fa9c883f1b55e9d0635886ef.jpg";